import { BaseService } from "core/services";
import { TrackingCaseDocumentStreamRouteService } from "application/tracking-case/services";

class TrackingCaseDocumentStreamService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new TrackingCaseDocumentStreamRouteService());
    }

    create(params, formData) {
        const url = this.routeService.create(params);
        return this.apiClient.post(url, formData);
    }
}

export default TrackingCaseDocumentStreamService;